class LittleMattersStorefront {
  constructor() {
    this.menu = document.querySelector('[data-lm-mobile-menu]')
    this.menuToggle = document.querySelector('[data-lm-menu-toggle]')
    this.menuClose = document.querySelector('[data-lm-menu-close]')
    this.footer = document.querySelector('[data-lm-footer]')
    this.sticky = document.querySelector('[data-lm-sticky-atc]')
    this.heroCta = document.querySelector('[data-lm-hero-atc]')
    this.heroPassed = false
    this.footerVisible = false
    this.bindMenu()
    this.bindTracking()
    this.bindProductForms()
    this.bindStickyAtc()
    this.bindGuideSearch()
    this.bindGrievanceReference()
  }

  bindMenu() {
    if (!this.menu || !this.menuToggle) return
    const main = document.querySelector('#MainContent')
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    const setOpen = (open) => {
      this.menu.setAttribute('aria-hidden', String(!open))
      if ('inert' in this.menu) this.menu.inert = !open
      this.menuToggle.setAttribute('aria-expanded', String(open))
      document.body.classList.toggle('lm-menu-open', open)
      if (main && 'inert' in main) main.inert = open
      if (this.footer && 'inert' in this.footer) this.footer.inert = open
      if (open) this.menuClose?.focus()
      else this.menuToggle.focus()
    }
    this.menuToggle.addEventListener('click', () => setOpen(true))
    this.menuClose?.addEventListener('click', () => setOpen(false))
    this.menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)))
    document.addEventListener('keydown', (event) => {
      const open = this.menu.getAttribute('aria-hidden') === 'false'
      if (event.key === 'Escape' && open) setOpen(false)
      if (event.key !== 'Tab' || !open) return
      const focusable = [...this.menu.querySelectorAll(focusableSelector)].filter((element) => !element.hidden)
      if (!focusable.length) return
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    })
  }

  track(name, data = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: name, ...data })
    if (typeof window.gtag === 'function') window.gtag('event', name, data)
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data)
  }

  bindTracking() {
    document.querySelectorAll('[data-lm-event]').forEach((element) => {
      element.addEventListener('click', () => this.track(element.dataset.lmEvent, {
        placement: element.dataset.lmPlacement || undefined,
        label: element.textContent.trim().slice(0, 80)
      }))
    })
    document.querySelectorAll('details[data-lm-faq]').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (detail.open) this.track('faq_interaction', { question: detail.querySelector('summary')?.textContent.trim().slice(0, 100) })
      })
    })
  }

  bindProductForms() {
    document.querySelectorAll('form[data-lm-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        if (!window.fetch || form.dataset.lmNative === 'true') return
        event.preventDefault()
        const button = form.querySelector('button[type="submit"]')
        const initialText = button?.textContent
        if (button) {
          button.disabled = true
          button.textContent = 'Adding…'
        }
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          })
          if (!response.ok) throw new Error('Cart request failed')
          const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json())
          document.querySelectorAll('[data-lm-cart-count]').forEach((count) => { count.textContent = cart.item_count })
          this.track('add_to_cart', { placement: form.dataset.lmPlacement || 'product' })
          window.location.assign(window.Shopify.routes.root + 'cart')
        } catch (error) {
          form.submit()
        } finally {
          if (button) {
            button.disabled = false
            button.textContent = initialText
          }
        }
      })
    })
  }

  bindStickyAtc() {
    if (!this.sticky || !this.heroCta) return
    let frame = 0
    const update = () => {
      const heroRect = this.heroCta.getBoundingClientRect()
      const footerRect = this.footer?.getBoundingClientRect()
      this.heroPassed = heroRect.bottom < 0
      this.footerVisible = Boolean(footerRect && footerRect.top <= window.innerHeight + 96 && footerRect.bottom >= 0)
      this.sticky.classList.toggle('is-visible', this.heroPassed && !this.footerVisible)
      frame = 0
    }
    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update)
    }
    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', requestUpdate)
    update()
  }

  bindGuideSearch() {
    const input = document.querySelector('[data-lm-guide-search]')
    if (!input) return
    const cards = [...document.querySelectorAll('[data-lm-guide-card]')]
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase()
      cards.forEach((card) => { card.hidden = query.length > 0 && !card.textContent.toLowerCase().includes(query) })
    })
  }

  bindGrievanceReference() {
    const input = document.querySelector('[data-lm-grievance-reference]')
    if (!input) return
    const date = new Date()
    const stamp = [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('')
    const suffix = Math.random().toString(36).slice(2, 6).toUpperCase()
    input.value = `LM-GRV-${stamp}-${suffix}`
    document.querySelectorAll('[data-lm-reference-output]').forEach((element) => { element.textContent = input.value })
  }
}

const bootLittleMatters = () => new LittleMattersStorefront()
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootLittleMatters, { once: true })
else bootLittleMatters()
